var zify_snow_data= "eyJ0ZW1wbGF0ZSI6IjIiLCJzbm93X3ZhbHVlIjoie1wiZmxha2Vjb3VudFwiOlwiMjUwXCIsXCJmbGFrZWNvbG9yXCI6XCIjRkZGRkZGXCIsXCJtaW5zaXplXCI6XCIxXCIsXCJtYXhzaXplXCI6XCIxMFwiLFwibWluc3BlZWRcIjpcIjVcIixcIm1heHNwZWVkXCI6XCI1XCIsXCJzaGFkb3dcIjoxLFwic25vd2ljb25cIjpcIjI2XCIsXCJqcXVlcnlfaW5jbHVkZWRcIjowfSIsInN0YXR1cyI6MCwib25seV9ob21lcGFnZSI6MCwianF1ZXJ5X2luY2x1ZGVkIjowLCJ1cGRhdGVkX2F0IjoiMjAyMy0wMi0yNiAxNTo0Njo1NCJ9";var zify_snow_style = "IjxjYW52YXMgY2xhc3M9XCJ6aWZ5LXNub3ctY2FudmFzXCIgc3BlZWQ9XCIxXCIgaW50ZXJhY3Rpb249XCJmYWxzZVwiIHNpemU9XCIyXCIgY291bnQ9XCI5MFwiIG9wYWNpdHk9XCIwLjAwMDAxXCIgc3RhcnQtY29sb3I9XCJyZ2JhKDI1MywyNTIsMjUxLDEpXCIgZW5kLWNvbG9yPVwicmdiYSgyNTEsMjUyLDI1MywwLjMpXCIgd2luZC1wb3dlcj1cIjBcIiBpbWFnZT1cImZhbHNlXCIgd2lkdGg9XCIxMzY2XCIgaGVpZ2h0PVwiNjY3XCI+PFwvY2FudmFzPlxyXG48Y2FudmFzIGNsYXNzPVwiemlmeS1zbm93LWNhbnZhc1wiIHNwZWVkPVwiMlwiIGludGVyYWN0aW9uPVwidHJ1ZVwiIHNpemU9XCI2XCIgY291bnQ9XCI0MFwiIHN0YXJ0LWNvbG9yPVwicmdiYSgyNTMsMjUyLDI1MSwxKVwiIGVuZC1jb2xvcj1cInJnYmEoMjUxLDI1MiwyNTMsMC4zKVwiIG9wYWNpdHk9XCIwLjAwMDAxXCIgd2luZC1wb3dlcj1cIjJcIiBpbWFnZT1cImZhbHNlXCIgd2lkdGg9XCIxMzY2XCIgaGVpZ2h0PVwiNjY3XCI+PFwvY2FudmFzPlxyXG48Y2FudmFzIGNsYXNzPVwiemlmeS1zbm93LWNhbnZhc1wiIHNwZWVkPVwiLTVcIiBpbnRlcmFjdGlvbj1cInRydWVcIiBzaXplPVwiMjVcIiBjb3VudD1cIjE1XCIgd2luZC1wb3dlcj1cIi0zXCIgaW1hZ2U9XCJodHRwczpcL1wvc25vdy56aWZ5YXBwLmNvbVwvaW1hZ2VzXC9mcm9udGVuZFwvc25vd19pY29uc1wvc25vdy0yNi5wbmdcIiB3aWR0aD1cIjEzNjZcIiBoZWlnaHQ9XCI2NjdcIj48XC9jYW52YXM+XHJcbjxzdHlsZSB0eXBlPVwidGV4dFwvY3NzXCI+LnppZnktc25vdy1jYW52YXMge2Rpc3BsYXk6IGJsb2NrO3dpZHRoOiAxMDAlO2hlaWdodDogMTAwJTt0b3A6IDA7bGVmdDogMDtwb3NpdGlvbjogZml4ZWQ7cG9pbnRlci1ldmVudHM6IG5vbmU7ei1pbmRleDogOTk5OTt9PFwvc3R5bGU+Ig==";// JavaScript Document

(function($){
	var $window = window,
		$timeout = setTimeout;
		
	window.Snow = function(element, settings) {
		this.settings = settings, 
		this.flakes = [], 
		this.flakeCount = settings.count, 
		this.mx = -100, 
		this.my = -100,
		function() {
			var requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
				$timeout(callback, 1e3 / 60)
			};
			$window.requestAnimationFrame = requestAnimationFrame
		}(), 
		this.init(element)
	};
	Snow.prototype.init = function(element) {
		this.canvas = element.get(0), this.ctx = this.canvas.getContext("2d"), this.canvas.width = $window.innerWidth, this.canvas.height = $window.innerHeight, this.flakes = [];
		for (var i = 0; i < this.flakeCount; i++) {
			var x = Math.floor(Math.random() * this.canvas.width),
				y = Math.floor(Math.random() * this.canvas.height),
				size = Math.floor(100 * Math.random()) % this.settings.size + 2,
				speed = Math.floor(100 * Math.random()) % this.settings.speed + Math.random() * size / 10 + .5,
				opacity = .5 * Math.random() + this.settings.opacity;
			this.flakes.push({
				speed: speed,
				velY: speed,
				velX: 0,
				x: x,
				y: y,
				size: size,
				stepSize: Math.random() / 30,
				step: 0,
				angle: 180,
				opacity: opacity
			})
		}
		1 == this.settings.interaction && this.canvas.addEventListener("mousemove", function(e) {
			this.mx = e.clientX, this.my = e.client
		});
		var thiz = this;
		$($window).resize(function() {
			thiz.ctx.clearRect(0, 0, thiz.canvas.width, thiz.canvas.height), thiz.canvas.width = $window.innerWidth, thiz.canvas.height = $window.innerHeight
		});
		if(typeof this.settings.image === "string") {
			this.image = $("<img src='" + this.settings.image + "' style='display: none'>");
		};
		
		this.snow();
	}, Snow.prototype.snow = function() {
		var thiz = this,
			render = function() {
				thiz.ctx.clearRect(0, 0, thiz.canvas.width, thiz.canvas.height);
				for (var i = 0; i < thiz.flakeCount; i++) {
					var flake = thiz.flakes[i],
						x = thiz.mx,
						y = thiz.my,
						minDist = 100,
						x2 = flake.x,
						y2 = flake.y,
						dist = Math.sqrt((x2 - x) * (x2 - x) + (y2 - y) * (y2 - y));
					if (minDist > dist) {
						var force = minDist / (dist * dist),
							xcomp = (x - x2) / dist,
							ycomp = (y - y2) / dist,
							deltaV = force / 2;
						flake.velX -= deltaV * xcomp, flake.velY -= deltaV * ycomp
					} else
						switch (flake.velX *= .98, flake.velY <= flake.speed && (flake.velY = flake.speed), thiz.settings.windPower) {
							case !1:
								flake.velX += Math.cos(flake.step += .05) * flake.stepSize;
								break;
							case 0:
								flake.velX += Math.cos(flake.step += .05) * flake.stepSize;
								break;
							default:
								flake.velX += .01 + thiz.settings.windPower / 100
						}
					if (flake.y += flake.velY, flake.x += flake.velX, (flake.y >= thiz.canvas.height || flake.y <= 0) && thiz.resetFlake(flake), (flake.x >= thiz.canvas.width || flake.x <= 0) && thiz.resetFlake(flake), 0 == thiz.settings.image) {
						var grd = thiz.ctx.createRadialGradient(flake.x, flake.y, 0, flake.x, flake.y, flake.size - 1);
						grd.addColorStop(0, thiz.settings.startColor), grd.addColorStop(1, thiz.settings.endColor), thiz.ctx.fillStyle = grd, thiz.ctx.beginPath(), thiz.ctx.arc(flake.x, flake.y, flake.size, 0, 2 * Math.PI), thiz.ctx.fill()
					} else
						thiz.ctx.drawImage(thiz.image.get(0), flake.x, flake.y, 2 * flake.size, 2 * flake.size)
				}
				$window.cancelAnimationFrame(render), $window.requestAnimationFrame(render)
			};
		render()
	}, Snow.prototype.resetFlake = function(flake) {
		if (0 == this.settings.windPower || 0 == this.settings.windPower)
			flake.x = Math.floor(Math.random() * this.canvas.width), flake.y = 0;
		else if (this.settings.windPower > 0) {
			var xarray = Array(Math.floor(Math.random() * this.canvas.width), 0),
				yarray = Array(0, Math.floor(Math.random() * this.canvas.height)),
				allarray = Array(xarray, yarray),
				selected_array = allarray[Math.floor(Math.random() * allarray.length)];
			flake.x = selected_array[0], flake.y = selected_array[1]
		} else {
			var xarray = Array(Math.floor(Math.random() * this.canvas.width), 0),
				yarray = Array(this.canvas.width, Math.floor(Math.random() * this.canvas.height)),
				allarray = Array(xarray, yarray),
				selected_array = allarray[Math.floor(Math.random() * allarray.length)];
			flake.x = selected_array[0], flake.y = selected_array[1]
		}
		flake.size = Math.floor(100 * Math.random()) % this.settings.size + 2, flake.speed = Math.floor(100 * Math.random()) % this.settings.speed + Math.random() * flake.size / 10 + .5, flake.velY = flake.speed, flake.velX = 0, flake.opacity = .5 * Math.random() + this.settings.opacity
	};
	
	$.fn.snow = function(){
		$(this).each(function(i, e) {
			var scope = {};
			$.each(e.attributes,function(index, key) {
				scope[ $.camelCase(key.name) ] = Number.isFinite( Number(key.value) ) ? Number(key.value) : key.value
			});
			if ( typeof scope.image === "string" && scope.image === "false" ) {scope.image = false};
			
			new Snow($(e), {
				speed: 1||0,
				interaction: scope.interaction||!0,
				size: scope.size||2,
				count: scope.count||200,
				opacity: scope.opacity||1,
				startColor: scope.startColor||"rgba(255,255,255,1)",
				endColor: scope.endColor||"rgba(255,255,255,0)",
				windPower: scope.windPower||0,
				image: scope.image||!1
			});
		});
	}
})(jQuery);
/*Zifyapp JS*/
!(function(){  
  var loadScript = function(url, callback){
    var script = document.createElement("script");
    script.type = "text/javascript";
    // If the browser is Internet Explorer.
    if (script.readyState){ 
      script.onreadystatechange = function(){
        if (script.readyState == "loaded" || script.readyState == "complete"){
          script.onreadystatechange = null;
          callback();
        }
      };
    // For any other browser.
    } else {
      script.onload = function(){
      callback();
      };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  };

  /* This is my app's JavaScript */
  var zify_snow_javaScript = function(jQuery){
    var B64={alphabet:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",lookup:null,ie:/MSIE /.test(navigator.userAgent),ieo:/MSIE [67]/.test(navigator.userAgent),encode:function(a){var e,f,g,b=B64.toUtf8(a),c=-1,d=b.length,h=[,,];if(B64.ie){for(var i=[];++c<d;)e=b[c],f=b[++c],h[0]=e>>2,h[1]=(3&e)<<4|f>>4,isNaN(f)?h[2]=h[3]=64:(g=b[++c],h[2]=(15&f)<<2|g>>6,h[3]=isNaN(g)?64:63&g),i.push(B64.alphabet.charAt(h[0]),B64.alphabet.charAt(h[1]),B64.alphabet.charAt(h[2]),B64.alphabet.charAt(h[3]));return i.join("")}for(var i="";++c<d;)e=b[c],f=b[++c],h[0]=e>>2,h[1]=(3&e)<<4|f>>4,isNaN(f)?h[2]=h[3]=64:(g=b[++c],h[2]=(15&f)<<2|g>>6,h[3]=isNaN(g)?64:63&g),i+=B64.alphabet[h[0]]+B64.alphabet[h[1]]+B64.alphabet[h[2]]+B64.alphabet[h[3]];return i},decode:function(a){if(a.length%4)throw new Error("InvalidCharacterError: 'B64.decode' failed: The string to be decoded is not correctly encoded.");var b=B64.fromUtf8(a),c=0,d=b.length;if(B64.ieo){for(var e=[];d>c;)b[c]<128?e.push(String.fromCharCode(b[c++])):b[c]>191&&b[c]<224?e.push(String.fromCharCode((31&b[c++])<<6|63&b[c++])):e.push(String.fromCharCode((15&b[c++])<<12|(63&b[c++])<<6|63&b[c++]));return e.join("")}for(var e="";d>c;)e+=b[c]<128?String.fromCharCode(b[c++]):b[c]>191&&b[c]<224?String.fromCharCode((31&b[c++])<<6|63&b[c++]):String.fromCharCode((15&b[c++])<<12|(63&b[c++])<<6|63&b[c++]);return e},toUtf8:function(a){var d,b=-1,c=a.length,e=[];if(/^[\x00-\x7f]*$/.test(a))for(;++b<c;)e.push(a.charCodeAt(b));else for(;++b<c;)d=a.charCodeAt(b),128>d?e.push(d):2048>d?e.push(192|d>>6,128|63&d):e.push(224|d>>12,128|63&d>>6,128|63&d);return e},fromUtf8:function(a){var c,b=-1,d=[],e=[,,];if(!B64.lookup){for(c=B64.alphabet.length,B64.lookup={};++b<c;)B64.lookup[B64.alphabet.charAt(b)]=b;b=-1}for(c=a.length;++b<c&&(e[0]=B64.lookup[a.charAt(b)],e[1]=B64.lookup[a.charAt(++b)],d.push(e[0]<<2|e[1]>>4),e[2]=B64.lookup[a.charAt(++b)],64!=e[2])&&(d.push((15&e[1])<<4|e[2]>>2),e[3]=B64.lookup[a.charAt(++b)],64!=e[3]);)d.push((3&e[2])<<6|e[3]);return d}};
    var zify_snow_data_response =JSON.parse(B64.decode(zify_snow_data));
    var zify_snow_style_response =JSON.parse(B64.decode(zify_snow_style));
    var snow_array = JSON.parse(zify_snow_data_response.snow_value);
    if(zify_snow_data_response.status == 1){
      if(zify_snow_data_response.only_homepage == 1 && window.location.pathname == '/'){
        snowFc(zify_snow_data_response,zify_snow_style_response,snow_array);
      }
      if(zify_snow_data_response.only_homepage == 0){
        snowFc(zify_snow_data_response,zify_snow_style_response,snow_array);
      }
    }
  };
    
  function snowFc(zify_snow_data_response,zify_snow_style_response,snow_array){
    jQuery(document).ready(function(){
      if(zify_snow_data_response.template == 1){
        jQuery(document).snowfall({
          flakeCount : Number(snow_array.flakecount),
          flakeColor : '#'+snow_array.flakecolor,
          flakeIndex: 999999,
          minSize : Number(snow_array.minsize),
          maxSize : Number(snow_array.maxsize),
          minSpeed : Number(snow_array.minspeed),
          maxSpeed : Number(snow_array.maxspeed),
          round : true,
          shadow : snow_array.shadow,
          collection : false,
          collectionHeight : 40,
          deviceorientation : true
        });
      }
      if(zify_snow_data_response.template == 2){
        jQuery('body').append(zify_snow_style_response); 
        jQuery(".zify-snow-canvas").snow();
      }
    });
  }
  
  function check_zify_snow_scripttag() {
    var scripts = document.getElementsByTagName('script');
    for (var i = scripts.length; i--;) {
        if(scripts[i].innerText.indexOf('asyncLoad')>=0&&scripts[i].innerText.indexOf("snow.zifyapp.com")>=0)
        {
          console.log('Zifyapp snow app is working.');
          return true;
        }
    }
    return false;
  }
  if(typeof jQuery == 'undefined' || typeof jQuery.fn.on == 'undefined') {
    loadScript('//code.jquery.com/jquery-3.4.1.min.js', function(){
    ZIFYAPP = jQuery.noConflict(true);
    ZIFYAPP(document).ready(function() {
        if(check_zify_snow_scripttag()){
          zify_snow_javaScript(ZIFYAPP);
        }
    });
  });
  } else {
      if(check_zify_snow_scripttag()){
        zify_snow_javaScript(jQuery);
      }
  }
})();